import { render, staticRenderFns } from "./GoogleSignup.vue?vue&type=template&id=5e3112ae&lang=pug&"
import script from "./GoogleSignup.vue?vue&type=script&lang=ts&"
export * from "./GoogleSignup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports